import api from "./api";
import useFeatureStore from "../store/useFeatureStore";

export async function GetActivityLogs(id, modelName = "") {
  console.log("model  Name", modelName)
  try {
    const response = await api.get("activity/logs/", {
      params: {
        model_name: modelName,
        object_id: id,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching activity logs:", error);
    throw error;
  }
}

export async function FeatureListApi() {
  try {
    const response = await api.get("subscriptions/feature-flag/");
    return response;
  } catch (error) {
    console.log("Error fetching features:", error);
    throw error;
  }
}

export async function getLatestReleasePopup() {
  try {
    console.log("Calling getLatestReleasePopup API...");
    const response = await api.get("release-notes/popup/");
    console.log("getLatestReleasePopup response:", response);
    return response;
  } catch (error) {
    console.log("Error fetching release popup:", error);
    return { data: { show_popup: false, release: null } };
  }
}

export async function markReleaseAsSeen(releaseId) {
  try {
    const response = await api.post("release-notes/mark-seen/", {
      release_id: releaseId,
    });
    return response;
  } catch (error) {
    console.log("Error marking release as seen:", error);
  }
}

// src/services/CommonApi.js  — add this export

export async function getSubscriptionFeatures() {
  try {
    const response = await api.get("subscriptions/my-features/");
    return response;
  } catch (error) {
    console.log("Error fetching subscription features:", error);
    return { data: { feature_codes: [] } };
  }
}

export async function getEmailConfigurations() {
  try {
    const response = await api.get("organization/email-configurations/");
    return response.data;
  } catch (error) {
    console.error("Error fetching email configurations:", error);
    throw error;
  }
}

export async function sendDocumentEmail(payload) {
  try {
    const response = await api.post("organization/send-email/", payload);
    return response.data;
  } catch (error) {
    console.error("Error sending document email:", error);
    throw error;
  }
}
export async function updateEmailConfigurations(payload) {
  try {
    const response = await api.post("organization/email-configurations/", payload);
    return response.data;
  } catch (error) {
    console.error("Error updating email configurations:", error);
    throw error;
  }
}

export async function getZatcaInvoiceConfigurations() {
  try {
    const response = await api.get("organization/zatca-invoice-configurations/");
    return response.data;
  } catch (error) {
    console.error("Error fetching zatca invoice configurations:", error);
    throw error;
  }
}

export async function updateZatcaInvoiceConfigurations(payload) {
  try {
    const response = await api.post("organization/zatca-invoice-configurations/", payload);
    return response.data;
  } catch (error) {
    console.error("Error updating zatca invoice configurations:", error);
    throw error;
  }
}
export async function getGSTInvoiceConfigurations() {
  try {
    const response = await api.get("organization/gst-invoice-configurations/");
    return response.data;
  } catch (error) {
    console.error("Error fetching gst invoice configurations:", error);
    throw error;
  }
}

export async function updateGSTInvoiceConfigurations(payload) {
  try {
    const response = await api.post("organization/gst-invoice-configurations/", payload);
    return response.data;
  } catch (error) {
    console.error("Error updating gst invoice configurations:", error);
    throw error;
  }
}

export async function getUserBootstrap() {
  try {
    const response = await api.get("accounts/users/bootstrap/");
    return response;
  } catch (error) {
    console.log(error);
  }
}